import usePinata from "./usePinata"

export default usePinata
